import { Suspense, useState } from 'react'

import { create } from '@bufbuild/protobuf'
import { useTranslation } from 'react-i18next'

import { Flex, Text, useDisclosure } from '@chakra-ui/react'

import {
  Loading,
  SideMenuLayoutBreadcrumb,
  SideMenuLayoutContentLayout,
} from '@enechain/ecloud-designsystem'

import {
  SessionInformation,
  SessionInformationSchema,
} from '~/gen/proto/bff/v1/model_pb'
import FinishSessionModal from '~/pages/Profile/components/FinishSessionModal'
import { ProfileEditForm } from '~/pages/Profile/components/ProfileEditForm'
import { SessionListTable } from '~/pages/Profile/components/SessionListTable'

export const Profile: React.FC = () => {
  const { t } = useTranslation()
  const finishSessionDisclosure = useDisclosure()
  const [sessionInformation, setSessionInformation] =
    useState<SessionInformation>(create(SessionInformationSchema))
  const onFinish = (sessionInformation: SessionInformation): void => {
    setSessionInformation(sessionInformation)
    finishSessionDisclosure.onOpen()
  }

  return (
    <SideMenuLayoutContentLayout
      header={
        <Flex alignItems="center" justifyContent="space-between" width="full">
          <SideMenuLayoutBreadcrumb
            items={[
              {
                label: t('pages.profile.title'),
                bold: true,
              },
            ]}
          />
        </Flex>
      }
    >
      <Flex
        flexDirection="column"
        gap="6"
        width="960px"
        maxWidth="90%"
        margin="auto"
        padding="4"
      >
        <Suspense fallback={<Loading />}>
          <ProfileEditForm />
        </Suspense>
        <Suspense fallback={<Loading />}>
          <Text textStyle="headerMd">{t('pages.profile.session_list')}</Text>
          <SessionListTable onFinish={onFinish} />
          <FinishSessionModal
            sessionInformation={sessionInformation}
            open={finishSessionDisclosure.open}
            onClose={finishSessionDisclosure.onClose}
            onSuccess={finishSessionDisclosure.onClose}
          />
        </Suspense>
      </Flex>
    </SideMenuLayoutContentLayout>
  )
}
